import queue from 'async.queue';

export const orderFinalizeQueue = queue(({ actionFn, params }, callback) => {
  actionFn(...params)
    .then(result => {
      callback(null, result);
    })
    .catch(err => {
      callback(err);
    });
}, 1);
